<div class="modal-header">
  <h4 class="modal-title text-center w-100">Pay Overdue Contract Payment</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row m-0 mt-3">
    <div class="col-12 mb-5">
      Uh oh! Looks like you already have an overdue contract. You’ll need to make your overdue payments before we can create a new contract for you.
    </div>
    <div class="col-6 text-center">
      <button type="button" class="btn btn-secondary py-2 px-4 " (click)="refreshData()">
        Refresh
      </button>
    </div>
    <div class="col-6 text-center">
      <button class="btn btn-primary py-2 px-4 ">
        <a style="color: aliceblue;" target="_blank" [routerLink]="['/pay-recurring', recurring_token]">View Details</a>
      </button>
    </div>
    <div class="col-12 text-center mt-5">
      <span>
        Need Help? <a class="text-bold" href="https://www.credee.com/support" target="_blank">Click Here</a> to contact Credee Support
      </span>
    </div>
  </div>
</div>